module.exports = __webpack_public_path__ + "static/media/american-express.7d284eaa.png";